import classnames from 'classnames';
import _ from 'lodash';
import React from 'react';
import useSWR from 'swr';

import CommentPopup from 'components/CommentPopup';
import Footer from 'components/Footer';
import MaxWidthContainer from 'components/MaxWidthContainer';
import Menubar from 'components/Menubar';
import MobileTabBar from 'components/MobileTabBar';
import Link from 'next/link';

import RewardRedeemModal from 'components/RewardRdeemModal';

import { useAppLaunch } from 'contexts/AppLaunch';
import { useUserAuth } from 'contexts/UserAuth';

import { NextSeo } from 'next-seo';
import { useRouter } from 'next/router';
import { swrFetcher } from 'utils/api';
const { useEffect, useState } = React;

export default function Rewards() {
  const { user, getAuthorizationHeader } = useUserAuth();
  const { categoryTree, notifications } = useAppLaunch();
  const router = useRouter();

  const { query } = router;

  const {
    isLoading: isRewardsLoading,
    data: {
      promotion_info: promotionInfo,
      reward_info: rewardInfo,
      rewards,
      promotions,
    },
  } = useSWR('/api/v2/rewards', (url) => swrFetcher(url), {
    fallbackData: {
      promotion_info: {},
      reward_info: null,
      rewards: [],
      promotions: [],
    },
  });

  const [filteredRewards, setFilteredRewards] = useState([]);

  const {
    data: { redeem_list: redeemList },
    mutate: mutateRedeemList,
  } = useSWR(
    user ? '/api/v2/me/redeemList' : null,
    (url) => swrFetcher(url, getAuthorizationHeader),
    {
      fallbackData: {
        redeem_list: [],
      },
    }
  );
  const redeemRewardTotal = _.sumBy(redeemList, 'count');

  const { data: pendingRedeems } = useSWR(
    user ? '/api/v3/me/pendingRedeems' : null,
    (url) => swrFetcher(url, getAuthorizationHeader),
    { fallbackData: [] }
  );

  const [showRedeemModal, setShowRedeemModal] = useState(false);

  //core properties
  const [tabSelectionState, setTabSelectionState] = useState(0);
  const [searchSortingMobileState, setSearchSortingMobileState] =
    useState(false);
  const [searchFilterMobileState, setSearchFilterMobileState] = useState(false);

  const [rewardCategories, setRewardCategories] = useState([]);

  useEffect(() => {
    const filterSecondCategories = _.reduce(
      rewards,
      (acc, r) => {
        return acc.concat(r.second_categories);
      },
      []
    );
    setRewardCategories(_.uniq(filterSecondCategories));
  }, [rewards]);

  useEffect(() => {
    if (user) {
      const queryParameters = new URLSearchParams(window.location.search);
      const list = queryParameters.get('list');
      if (list != null) {
        mutateRedeemList();
        setShowRedeemModal(true);
      } else {
        setTabSelectionState(0);
        const queryParameters = new URLSearchParams(window.location.search);
        const list = queryParameters.get('tab');
        if (list == 'code') {
          setTabSelectionState(1);
        }
      }
    }
  }, [user, query]);

  const [rewardFilters, setRewardFilters] = useState([
    {
      key: 'sorting',
      name: '排序',
      expand: true,
      multiple: false,
      options: [
        {
          value: 0,
          name: '所需積分高至低',
          selected: false,
        },
        {
          value: 1,
          name: '所需積分低至高',
          selected: false,
        },
        {
          value: 2,
          name: '庫存高至低',
          selected: false,
        },
        {
          value: 3,
          name: '庫存低至高',
          selected: false,
        },
      ],
    },
    {
      key: 'score',
      name: '所需積分',
      expand: true,
      multiple: false,
      options: [
        {
          value: 0,
          name: '全選',
          selected: true,
        },
        {
          value: 1,
          name: '✦ $200 以下',
          selected: false,
        },
        {
          value: 2,
          name: '✦ $200 至 ✦ $400',
          selected: false,
        },
        {
          value: 3,
          name: '✦ $400 至 ✦ $800',
          selected: false,
        },
        {
          value: 4,
          name: '✦ $800 以上',
          selected: false,
        },
      ],
    },
  ]);

  useEffect(() => {
    if (!_.some([categoryTree, rewardCategories], _.isEmpty)) {
      const secondCategoriesMap = _.reduce(
        categoryTree,
        (acc, category) => {
          category.second_categories.forEach((secondCategory) => {
            acc[secondCategory.id] = secondCategory;
          });
          return acc;
        },
        {}
      );
      setRewardFilters((prev) => {
        const newPrev = [...prev];
        newPrev[2] = {
          key: 'category',
          name: '產品類型',
          expand: true,
          multiple: true,
          options: [{ value: -1, name: '全選', selected: true }].concat(
            _.reduce(
              rewardCategories,
              (acc, c) => {
                if (secondCategoriesMap[c]) {
                  acc.push({
                    value: c,
                    name: secondCategoriesMap[c].name,
                    selected: true,
                  });
                }
                return acc;
              },
              []
            )
          ),
        };
        return newPrev;
      });
    }
  }, [categoryTree, rewardCategories]);

  useEffect(() => {
    if (rewards) {
      let filterRewards = [...rewards];
      rewardFilters.forEach((r) => {
        if (r.key === 'sorting') {
          const selected = r.options.find((o) => o.selected);
          if (selected) {
            switch (selected.value) {
              case 0:
                filterRewards = _.orderBy(filterRewards, ['score'], ['desc']);
                break;
              case 1:
                filterRewards = _.orderBy(filterRewards, ['score'], ['asc']);
                break;
              case 2:
                filterRewards = _.orderBy(
                  filterRewards,
                  ['inventory'],
                  ['desc']
                );
                break;
              case 3:
                filterRewards = _.orderBy(
                  filterRewards,
                  ['inventory'],
                  ['asc']
                );
                break;
            }
          } else {
            filterRewards = filterRewards;
          }
        } else if (r.key === 'score') {
          const selected = r.options.find((o) => o.selected);
          switch (selected.value) {
            case 0:
              filterRewards = filterRewards;
              break;
            case 1:
              filterRewards = filterRewards.filter((r) => r.score <= 200);
              break;
            case 2:
              filterRewards = filterRewards.filter(
                (r) => r.score > 200 && r.score <= 400
              );
              break;
            case 3:
              filterRewards = filterRewards.filter(
                (r) => r.score > 400 && r.score <= 800
              );
              break;
            case 4:
              filterRewards = filterRewards.filter((r) => r.score > 800);
              break;
          }
        } else if (r.key === 'category') {
          if (r.options[0] && r.options[0].selected) {
          } else {
            const selectedIds = _.reduce(
              r.options,
              (acc, o) => {
                if (o.selected) {
                  acc.push(o.value);
                }
                return acc;
              },
              []
            );
            filterRewards = filterRewards.filter((r) => {
              return r.second_categories.some((c) => selectedIds.includes(c));
            });
          }
        }
      });
      setFilteredRewards(filterRewards);
    } else {
      setFilteredRewards(rewards);
    }
  }, [rewards, rewardFilters]);

  const [isCommentModalShow, setIsCommentModalShow] = useState(false);

  return (
    <div>
      <NextSeo
        title={
          router.asPath.includes('tab=')
            ? '優惠碼｜最新化妝品護膚品折扣碼及優惠 | Sorra'
            : '兌換禮物｜免費試用裝及化妝護膚品好禮換領 | Sorra'
        }
        description={
          router.asPath.includes('tab=')
            ? 'Sorra優惠碼專區，讓你輕鬆找到各美妝護膚產品及服務的最新優惠碼，讓你享受獨家優惠與限時折扣，助你以更優惠價錢購買心儀產品或服務！'
            : 'Sorra兌換禮物平台，讓會員以積分兌換免費試用裝及化妝護膚品好禮。會員分享真實評價可賺取積分，利用積分即可換領心儀美妝護膚禮品！'
        }
      />

      <main>
        <Menubar
          props={{
            homeExtend: false,
            sourceUI: 'Rewards',
          }}
        />

        <div
          className={
            'globals-centerContentsMargin relative' +
            (notifications.length > 0 ? ' withNoti' : '')
          }
        >
          <div className="w-full border-b-[1px] border-gray-300">
            <MaxWidthContainer className="relative gap-x-[32px] px-4">
              <div className="py-[16px] text-3xl font-bold text-sorra-gray-900 lg:py-[32px] lg:text-4xl">
                獎賞優惠
              </div>
              {rewardInfo && (
                <div className="relative mb-8 flex w-full items-center rounded-lg border border-gray-300 p-4 lg:absolute lg:bottom-6 lg:right-8 lg:mb-0 lg:w-[384px]">
                  {pendingRedeems.length ? (
                    <>
                      <div className="grow">
                        <div className="flex text-base font-medium text-sorra-gray-900">
                          ⚠ 你尚有未完成付款之訂單
                        </div>
                        <div className="mt-[8px] text-xs font-medium text-sorra-gray-800">
                          逾時處理將自動取消訂單
                        </div>
                      </div>
                      <button
                        className="flex w-[75px] items-center justify-center rounded-lg bg-sorra-pink px-3 py-2 text-xs text-white"
                        onClick={() => {
                          router.push('/profile/redeem');
                        }}
                      >
                        去付款
                      </button>
                    </>
                  ) : (
                    <>
                      <div
                        className="grow cursor-pointer"
                        onClick={() => {
                          router.push('/profile/mission');
                        }}
                      >
                        <div className="flex text-base font-medium text-sorra-gray-900">
                          {rewardInfo.banner_main_text}
                          <img
                            src="/svgs/sorra-points-small.svg"
                            className="mx-[8px]"
                          ></img>
                          ${rewardInfo.banner_main_score}
                        </div>
                        <div className="mt-[8px] text-xs font-medium text-sorra-gray-800">
                          {rewardInfo.banner_sub_text}
                        </div>
                      </div>
                      <div className="flex w-[20px] items-center justify-center">
                        <img
                          src="/svgs/chevron-right-pink.svg"
                          className="h-[20px] w-[20px]"
                        ></img>
                      </div>
                    </>
                  )}
                </div>
              )}

              <div className="hidden space-x-[32px] lg:flex">
                <div
                  className={
                    'cursor-pointer border-b-[3px] pb-[20px] text-xl text-sorra-gray-800 ' +
                    (tabSelectionState == 0
                      ? ' border-sorra-pink font-bold'
                      : ' border-white font-normal')
                  }
                  onClick={() => {
                    setTabSelectionState(0);
                  }}
                >
                  兌換禮物
                </div>
                <div
                  className={
                    'cursor-pointer border-b-[3px] pb-[20px] text-xl text-sorra-gray-800 ' +
                    (tabSelectionState == 1
                      ? ' border-sorra-pink font-bold'
                      : ' border-white font-normal')
                  }
                  onClick={() => {
                    setTabSelectionState(1);
                  }}
                >
                  優惠碼
                </div>
              </div>

              <div className="grid grid-cols-2 lg:hidden">
                <div className="flex w-full items-center justify-center">
                  <div
                    className={
                      'w-full max-w-[125px] cursor-pointer border-b-[3px] pb-[8px] text-center text-xl text-sorra-gray-800 ' +
                      (tabSelectionState == 0
                        ? ' border-sorra-pink font-bold'
                        : ' border-white font-normal')
                    }
                    onClick={() => {
                      setTabSelectionState(0);
                    }}
                  >
                    兌換禮物
                  </div>
                </div>
                <div className="flex w-full items-center justify-center">
                  <div
                    className={
                      'w-full max-w-[125px] cursor-pointer border-b-[3px] pb-[8px] text-center text-xl text-sorra-gray-800 ' +
                      (tabSelectionState == 1
                        ? ' border-sorra-pink font-bold'
                        : ' border-white font-normal')
                    }
                    onClick={() => {
                      setTabSelectionState(1);
                    }}
                  >
                    優惠碼
                  </div>
                </div>
              </div>
            </MaxWidthContainer>
          </div>

          <div className="">
            <MaxWidthContainer className="flew-row flex gap-x-6 p-4">
              {tabSelectionState === 0 && (
                <div className="hidden h-full w-[324px] lg:block lg:pt-[48px]">
                  {rewardFilters.map((filter, filterIdx) => {
                    return (
                      <div
                        key={filter.key}
                        className="mb-6 w-full space-y-4 border-b-[1px] border-gray-300 pb-4"
                      >
                        <div className="flex text-base">
                          <div className="grow font-bold text-sorra-gray-900">
                            {filter.name}
                          </div>
                          <img
                            className="cursor-pointer"
                            src={
                              !filter.expand
                                ? '/svgs/index-section-expand.svg'
                                : '/svgs/index-section-collapse.svg'
                            }
                            onClick={() => {
                              setRewardFilters((prev) => {
                                return prev.map((f, i) => {
                                  if (i === filterIdx) {
                                    return { ...f, expand: !f.expand };
                                  }
                                  return f;
                                });
                              });
                            }}
                          ></img>
                        </div>
                        {filter.expand &&
                          filter.options.map((option, optionIdx) => {
                            return (
                              <div
                                key={option.value}
                                className="mb-4 flex items-center text-base font-normal"
                              >
                                <input
                                  type={filter.multiple ? 'checkbox' : 'radio'}
                                  value={option.value}
                                  checked={option.selected}
                                  className="h-5 w-5 text-sorra-pink focus:ring-0 focus:ring-offset-0"
                                  onChange={(e) => {
                                    const v = e.target.value;
                                    setRewardFilters((prev) => {
                                      return prev.map((f, i) => {
                                        if (i === filterIdx) {
                                          if (filter.multiple) {
                                            if (option.value === -1) {
                                              return {
                                                ...f,
                                                options: f.options.map(
                                                  (o, oi) => ({
                                                    ...o,
                                                    selected: !option.selected,
                                                  })
                                                ),
                                              };
                                            }
                                            const newOptions = f.options.map(
                                              (o, oi) => {
                                                return {
                                                  ...o,
                                                  selected:
                                                    oi === optionIdx
                                                      ? !o.selected
                                                      : o.selected,
                                                };
                                              }
                                            );
                                            const allCheck = _.reduce(
                                              newOptions,
                                              (acc, o) => {
                                                if (o.value !== -1) {
                                                  return acc && o.selected;
                                                } else {
                                                  return acc;
                                                }
                                              },
                                              true
                                            );
                                            newOptions[0].selected = allCheck;
                                            return {
                                              ...f,
                                              options: newOptions,
                                            };
                                          } else {
                                            return {
                                              ...f,
                                              options: f.options.map(
                                                (o, oi) => ({
                                                  ...o,
                                                  selected:
                                                    oi === optionIdx
                                                      ? true
                                                      : false,
                                                })
                                              ),
                                            };
                                          }
                                        }
                                        return f;
                                      });
                                    });
                                  }}
                                />
                                <label className="ml-2 text-sorra-gray-900">
                                  {option.name}
                                </label>
                              </div>
                            );
                          })}
                      </div>
                    );
                  })}
                </div>
              )}
              <div className="min-w-0 flex-grow">
                {tabSelectionState === 0 && (
                  <div className="grid w-full grid-cols-2 gap-4 lg:hidden">
                    <div
                      className="flex h-[40px] cursor-pointer items-center justify-center gap-x-[8px] rounded-lg border-[1px] border-gray-300 px-[20px] py-[8px]"
                      onClick={() => {
                        setSearchFilterMobileState(true);
                      }}
                    >
                      <img src="/svgs/filter.svg"></img>
                      <div>篩選</div>
                      <img src="/svgs/chevron-down-button.svg"></img>
                    </div>
                    <div
                      className="flex h-[40px] cursor-pointer items-center justify-center gap-x-[8px] rounded-lg border-[1px] border-gray-300 px-[20px] py-[8px]"
                      onClick={() => {
                        setSearchSortingMobileState(true);
                      }}
                    >
                      <img src="/svgs/sort-ascending.svg"></img>
                      <div>排序</div>
                      <img src="/svgs/chevron-down-button.svg"></img>
                    </div>
                  </div>
                )}
                {tabSelectionState === 0 && (
                  <>
                    {isRewardsLoading ? (
                      <div className="relative w-full pt-[100%]">
                        <div className="absolute left-0 top-0 flex h-full w-full flex-col items-center">
                          <div className="relative mt-20 h-[105px] w-[180px] lg:mt-[236px] lg:h-[161px] lg:w-[256px]">
                            <img
                              className="h-[160px] w-[160px]"
                              src="/images/search-placeholder.gif"
                            ></img>
                          </div>
                        </div>
                      </div>
                    ) : filteredRewards.length === 0 ? (
                      <div className="relative w-full pt-[100%]">
                        <div className="absolute left-0 top-0 flex h-full w-full flex-col items-center">
                          <div className="relative mt-20 h-[105px] w-[180px] lg:mt-[236px] lg:h-[161px] lg:w-[256px]">
                            <img
                              alt="placeholder"
                              src="/images/placeholders/search-empty.png"
                              className="h-full w-full object-contain"
                            />
                          </div>
                          <p className="mt-2 text-base font-medium text-[#111928] lg:mt-1.5 lg:text-2xl">
                            暫無結果
                          </p>
                        </div>
                      </div>
                    ) : (
                      <div className="grid grid-cols-2 gap-x-[16px] gap-y-[32px] pt-4 lg:grid-cols-3 lg:gap-x-[24px] lg:gap-y-[48px] lg:pt-[48px]">
                        {filteredRewards.map((reward) => {
                          const {
                            id,
                            name,
                            en_name,
                            brand,
                            image,
                            inventory,
                            score,
                            original_score = 0,
                            max_per_user = null,
                            app_only = false,
                          } = reward;

                          let redeemCount = 0;
                          redeemList.forEach((elementRedeem) => {
                            if (elementRedeem.reward.id === id) {
                              redeemCount = elementRedeem.count;
                            }
                          });

                          return (
                            <Link
                              prefetch={false}
                              key={id}
                              href={`rewards/gift/${id}`}
                              className="relative w-auto lg:w-[302px]"
                            >
                              <div className="relative flex aspect-[1/1] w-full items-center justify-center rounded-lg border border-[#E7E7E7] bg-white p-[0px] lg:p-[0px]">
                                <img
                                  src={
                                    image
                                      ? image.url
                                      : '/images/placeholders/product.png'
                                  }
                                  alt={image ? image.alternativeText : ''}
                                ></img>
                                <div
                                  className={
                                    'absolute right-[16px] top-[16px] rounded-full bg-sorra-pink px-[8px] text-sm font-medium text-white' +
                                    (redeemCount == 0 ? ' hidden' : '')
                                  }
                                >
                                  {redeemCount}
                                </div>
                              </div>
                              <div className="pt-6 text-sm text-sorra-gray-800">
                                {brand ? brand.name : ''}
                              </div>
                              <div className="pb-1 pt-1 text-lg font-medium text-sorra-gray-900">
                                {name || ''}
                                <br />
                                {en_name || ''}
                              </div>
                              {app_only === true && (
                                <div className="mb-2 flex">
                                  <div
                                    className="flex flex-row items-center gap-x-1 rounded-md px-2.5 py-0.5"
                                    style={{ backgroundColor: '#FFE0E5' }}
                                  >
                                    <img
                                      src={`/images/icons/badge-check.png`}
                                      className="h-[14px] w-[14px] object-contain"
                                    />
                                    <p
                                      className="text-xs font-medium"
                                      style={{ color: '#FF6079' }}
                                    >
                                      App限定
                                    </p>
                                  </div>
                                </div>
                              )}
                              <div className="flex">
                                <img
                                  src="/svgs/sorra-points-small.svg"
                                  className="mr-[8px]"
                                ></img>
                                <div className="flex items-center gap-x-2 text-base font-medium text-sorra-gray-900">
                                  <p
                                    className={
                                      original_score > 0
                                        ? 'text-sorra-pink'
                                        : ''
                                    }
                                  >
                                    {'$' + score}
                                  </p>
                                  {original_score > 0 && (
                                    <p className="font-normal line-through">{`$${original_score}`}</p>
                                  )}
                                  {!_.isNil(max_per_user) && (
                                    <p className="hidden text-sm text-[#9CA3AF] lg:block">
                                      (每人限換 {max_per_user} 件)
                                    </p>
                                  )}
                                </div>
                              </div>
                              {!_.isNil(max_per_user) && (
                                <p className="mt-2 block text-sm text-[#9CA3AF] lg:hidden">
                                  (每人限換 {max_per_user} 件)
                                </p>
                              )}
                              <div
                                className={
                                  'mt-2 text-xs font-medium text-sorra-gray-800' +
                                  (inventory == 0 || inventory >= 2
                                    ? ' hidden'
                                    : '')
                                }
                              >
                                剩餘最後{' '}
                                <span className="text-sorra-pink">
                                  {inventory}
                                </span>{' '}
                                件產品
                              </div>
                              <div
                                className={
                                  'mt-2 text-xs font-medium text-sorra-gray-800' +
                                  (inventory > 0 ? ' hidden' : '')
                                }
                              >
                                換完了～ 請期待新一輪獎賞！
                              </div>
                            </Link>
                          );
                        })}

                        <div
                          className="fixed bottom-[86px] left-0 flex h-[48px] w-full px-[16px] lg:bottom-[48px]"
                          style={{ pointerEvents: 'none' }}
                        >
                          <div
                            className={
                              'relative mx-auto flex w-full cursor-pointer items-center justify-center rounded-full bg-sorra-pink px-[40px] py-[12px] lg:w-auto' +
                              (redeemRewardTotal == 0 ? ' hidden' : '')
                            }
                            style={{ pointerEvents: 'auto' }}
                            onClick={() => {
                              // setModalShownState(1);
                              setShowRedeemModal(true);
                            }}
                          >
                            <img
                              src="/svgs/shopping-cart.svg"
                              className="mr-[12px]"
                            ></img>
                            <div className="text-base font-medium text-white">
                              換領清單 ({redeemRewardTotal})
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}
                {tabSelectionState === 1 && (
                  <div className="pt-[28px]">
                    <div className="flex">
                      <div className="grow text-xl font-bold text-sorra-gray-900 lg:text-2xl">
                        {promotionInfo.title}
                      </div>
                      <div className="flex items-end text-sm font-normal text-sorra-gray-800">
                        {promotionInfo.last_update}
                      </div>
                    </div>

                    <div className="flex flex-col gap-y-4 pt-6 lg:hidden">
                      {/* {blockTabContentCodesTmp} */}
                      {promotions.map((promotion, idx) => {
                        const { id, item_codename } = promotion;
                        return (
                          <a
                            key={id}
                            className="text-medium flex gap-x-1 text-sm text-sorra-gray-900"
                            href={'#rewards-code-item_' + idx}
                          >
                            <img
                              src="/svgs/index-partnership-arrow.svg"
                              className="mb-[auto] mt-[2px]"
                            ></img>
                            {item_codename}
                          </a>
                        );
                      })}
                    </div>

                    <div className="grid grid-cols-1 gap-x-[24px] gap-y-[20px] pt-[36px] lg:grid-cols-4">
                      {/* {blockTabContentItemsTmp} */}
                      {promotions.map((promotion, idx) => {
                        const {
                          id,
                          url,
                          item_title,
                          item_code,
                          item_codename,
                          item_content,
                          item_image,
                        } = promotion;
                        const imageUrl = _.get(item_image, 'url') || '';
                        const itemContentText =
                          _.get(_.head(item_content), 'text') || '';
                        const itemContentTag =
                          _.get(_.head(item_content), 'tag') || '';
                        return (
                          <div
                            key={id}
                            className="w-auto cursor-pointer overflow-hidden lg:w-[302px]"
                            id={'rewards-code-item_' + idx}
                          >
                            <div
                              className="rounded-lg border-l-[1px] border-r-[1px] border-t-[1px] border-gray-300 pb-[36px] pl-[16px] pr-[16px] pt-[16px]"
                              style={{ height: 'calc(100% - 91px)' }}
                              onClick={() => window.open(url, '_blank')}
                            >
                              <img src={imageUrl} className="h-[50px]"></img>
                              <div className="pt-[6px] text-base font-bold text-sorra-gray-900">
                                {item_title}
                              </div>
                              <div className="pt-[16px] text-base font-medium text-sorra-gray-900">
                                {itemContentText}
                              </div>
                              <div className="pt-[8px] text-sm font-normal text-sorra-gray-800">
                                {itemContentTag}
                              </div>
                            </div>
                            <div className="border-t-[1px] border-dashed border-gray-300"></div>
                            <div
                              className="relative h-[91px] rounded-lg border-b-[1px] border-l-[1px] border-r-[1px] border-gray-300 bg-[#FCE1E5]"
                              onClick={() => {
                                navigator.clipboard.writeText(item_code);

                                const rewards_share_toast_desktop =
                                  document.getElementById(
                                    'rewards_share_toast_desktop'
                                  );

                                if (
                                  rewards_share_toast_desktop.classList.contains(
                                    'hidden'
                                  )
                                ) {
                                  rewards_share_toast_desktop.classList.remove(
                                    'hidden'
                                  );

                                  window.setTimeout(function () {
                                    rewards_share_toast_desktop.classList.add(
                                      'hidden'
                                    );
                                  }, 5000);
                                }

                                const rewards_share_toast_mobile =
                                  document.getElementById(
                                    'rewards_share_toast_mobile'
                                  );

                                if (
                                  rewards_share_toast_mobile.classList.contains(
                                    'hidden'
                                  )
                                ) {
                                  rewards_share_toast_mobile.classList.remove(
                                    'hidden'
                                  );

                                  window.setTimeout(function () {
                                    rewards_share_toast_mobile.classList.add(
                                      'hidden'
                                    );
                                  }, 5000);
                                }
                              }}
                            >
                              <div className="absolute left-[-12px] top-[-12px] h-[24px] w-[24px] rounded-full border-[1px] border-gray-300 bg-[#FFFFFF]"></div>
                              <div className="absolute right-[-12px] top-[-12px] h-[24px] w-[24px] rounded-full border-[1px] border-gray-300 bg-[#FFFFFF]"></div>
                              <div className="flex h-full w-full items-center justify-center">
                                <div className="">
                                  <div className="text-center text-base font-normal text-sorra-gray-900">
                                    {item_codename}
                                  </div>
                                  <div className="text-center text-2xl font-bold text-sorra-pink">
                                    {item_code}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>

                    <div className="mt-[38px] hidden text-base font-normal text-sorra-gray-900 lg:block">
                      {promotionInfo.desktop_paragraph}
                    </div>
                    <div className="mt-[32px] block text-base font-normal text-sorra-gray-900 lg:hidden">
                      {promotionInfo.mobile_paragraph}
                    </div>
                  </div>
                )}
              </div>
            </MaxWidthContainer>
          </div>

          <div className="mt-4 flex w-full justify-center pb-10 text-sm text-sorra-gray-800">
            <Link
              prefetch={false}
              key="refund-policy"
              href={`/refund-policy`}
              className="relative underline"
            >
              退換政策
            </Link>
          </div>
          <div className="pt-6 lg:pt-24"></div>

          <div
            className="rewards-share-toast-desktop pointer-events-none hidden gap-x-[8px] lg:hidden"
            id="rewards_share_toast_desktop"
          >
            <img
              src="/svgs/check-circle-green.svg"
              className="h-[20px] w-[20px]"
            ></img>
            <div className="text-sm text-sorra-gray-800">已複製</div>
          </div>

          <div
            className="rewards-share-toast-mobile pointer-events-none hidden gap-x-[8px] lg:hidden"
            id="rewards_share_toast_mobile"
          >
            <img
              src="/svgs/check-circle-green.svg"
              className="h-[20px] w-[20px]"
            ></img>
            <div className="text-sm text-sorra-gray-800">已複製</div>
          </div>
        </div>

        <div
          className={
            'index-header-search-mobile-overlay fixed left-0 top-0 z-[50] flex h-full w-full flex-col' +
            (searchFilterMobileState == true ? ' block lg:hidden' : ' hidden')
          }
        >
          <div className="index-header-search-mobile-overlay-title relative flex w-full text-lg font-medium text-sorra-gray-900">
            <button
              className="border-text-gray-100 absolute left-0 mb-2 mr-2 h-[48px] w-[48px] rounded-lg border p-[14px] text-center text-sm font-medium text-gray-100 focus:outline-none focus:ring-4 focus:ring-blue-300"
              onClick={() => {
                setSearchFilterMobileState(false);
              }}
            >
              <img
                src="/svgs/modal-close.svg"
                className="h-[20px] w-[20px]"
              ></img>
            </button>
            <div className="h-[48px]">篩選</div>
          </div>
          <div className="grow overflow-x-hidden overflow-y-scroll py-8">
            {_.filter(rewardFilters, (rf) => {
              return rf.key !== 'sorting';
            }).map((filter, filterIdx, filterArr) => {
              return (
                <div
                  key={filter.key}
                  className={classnames(
                    'mb-6 w-full space-y-4 border-gray-300 pb-6',
                    {
                      'border-b-[1px]': filterArr.length - 1 !== filterIdx,
                    }
                  )}
                >
                  <div className="flex text-base">
                    <div className="grow font-bold text-sorra-gray-900">
                      {filter.name}
                    </div>
                  </div>
                  {filter.options.map((option, optionIdx) => {
                    return (
                      <div
                        key={option.value}
                        className="mb-4 flex items-center text-base font-normal"
                      >
                        <input
                          type={filter.multiple ? 'checkbox' : 'radio'}
                          value={option.value}
                          checked={option.selected}
                          className="h-5 w-5 text-sorra-pink focus:ring-0 focus:ring-offset-0"
                          onChange={(e) => {
                            const v = e.target.value;
                            setRewardFilters((prev) => {
                              return prev.map((f, i) => {
                                if (f.key === filter.key) {
                                  if (filter.multiple) {
                                    if (option.value === -1) {
                                      return {
                                        ...f,
                                        options: f.options.map((o, oi) => ({
                                          ...o,
                                          selected: !option.selected,
                                        })),
                                      };
                                    }
                                    const newOptions = f.options.map(
                                      (o, oi) => {
                                        return {
                                          ...o,
                                          selected:
                                            oi === optionIdx
                                              ? !o.selected
                                              : o.selected,
                                        };
                                      }
                                    );
                                    const allCheck = _.reduce(
                                      newOptions,
                                      (acc, o) => {
                                        if (o.value !== -1) {
                                          return acc && o.selected;
                                        } else {
                                          return acc;
                                        }
                                      },
                                      true
                                    );
                                    newOptions[0].selected = allCheck;
                                    return {
                                      ...f,
                                      options: newOptions,
                                    };
                                  } else {
                                    return {
                                      ...f,
                                      options: f.options.map((o, oi) => ({
                                        ...o,
                                        selected: oi === optionIdx ? v : false,
                                      })),
                                    };
                                  }
                                }
                                return f;
                              });
                            });
                          }}
                        />
                        <label className="ml-2 text-sorra-gray-900">
                          {option.name}
                        </label>
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </div>
          <div className="mt-[32px] h-[48px]">
            <button
              className="flex h-full w-full items-center justify-center gap-x-3 rounded-lg bg-sorra-pink px-8 py-3"
              onClick={() => setSearchFilterMobileState(false)}
            >
              <p className="text-sm text-white">確定</p>
            </button>
          </div>
        </div>

        <div
          className={
            'index-header-search-mobile-overlay fixed left-0 top-0 z-[50] flex h-full w-full flex-col' +
            (searchSortingMobileState == true ? ' block lg:hidden' : ' hidden')
          }
        >
          <div className="index-header-search-mobile-overlay-title relative flex w-full text-lg font-medium text-sorra-gray-900">
            <button
              className="border-text-gray-100 absolute left-0 mb-2 mr-2 h-[48px] w-[48px] rounded-lg border p-[14px] text-center text-sm font-medium text-gray-100 focus:outline-none focus:ring-4 focus:ring-blue-300"
              onClick={() => {
                setSearchSortingMobileState(false);
              }}
            >
              <img
                src="/svgs/modal-close.svg"
                className="h-[20px] w-[20px]"
              ></img>
            </button>
            <div className="h-[48px]">排序</div>
          </div>
          <div className="grow overflow-x-hidden overflow-y-scroll py-8">
            {_.filter(rewardFilters, (rf) => {
              return rf.key === 'sorting';
            }).map((filter, filterIdx, filterArr) => {
              return (
                <div
                  key={filter.key}
                  className={classnames(
                    'mb-6 w-full space-y-4 border-gray-300 pb-6',
                    {
                      'border-b-[1px]': filterArr.length - 1 !== filterIdx,
                    }
                  )}
                >
                  <div className="flex text-base">
                    <div className="grow font-bold text-sorra-gray-900">
                      {filter.name}
                    </div>
                  </div>
                  {filter.options.map((option, optionIdx) => {
                    return (
                      <div
                        key={option.value}
                        className="mb-4 flex items-center text-base font-normal"
                      >
                        <input
                          type={filter.multiple ? 'checkbox' : 'radio'}
                          value={option.value}
                          checked={option.selected}
                          className="h-5 w-5 text-sorra-pink focus:ring-0 focus:ring-offset-0"
                          onChange={(e) => {
                            const v = e.target.value;
                            setRewardFilters((prev) => {
                              return prev.map((f, i) => {
                                if (f.key === filter.key) {
                                  if (filter.multiple) {
                                    if (option.value === -1) {
                                      return {
                                        ...f,
                                        options: f.options.map((o, oi) => ({
                                          ...o,
                                          selected: !option.selected,
                                        })),
                                      };
                                    }
                                    const newOptions = f.options.map(
                                      (o, oi) => {
                                        return {
                                          ...o,
                                          selected:
                                            oi === optionIdx
                                              ? !o.selected
                                              : o.selected,
                                        };
                                      }
                                    );
                                    const allCheck = _.reduce(
                                      newOptions,
                                      (acc, o) => {
                                        if (o.value !== -1) {
                                          return acc && o.selected;
                                        } else {
                                          return acc;
                                        }
                                      },
                                      true
                                    );
                                    newOptions[0].selected = allCheck;
                                    return {
                                      ...f,
                                      options: newOptions,
                                    };
                                  } else {
                                    return {
                                      ...f,
                                      options: f.options.map((o, oi) => ({
                                        ...o,
                                        selected: oi === optionIdx ? v : false,
                                      })),
                                    };
                                  }
                                }
                                return f;
                              });
                            });
                          }}
                        />
                        <label className="ml-2 text-sorra-gray-900">
                          {option.name}
                        </label>
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </div>
          <div className="mt-[32px] h-[48px]">
            <button
              className="flex h-full w-full items-center justify-center gap-x-3 rounded-lg bg-sorra-pink px-8 py-3"
              onClick={() => setSearchSortingMobileState(false)}
            >
              <p className="text-sm text-white">確定</p>
            </button>
          </div>
        </div>

        <RewardRedeemModal
          show={showRedeemModal}
          setShow={setShowRedeemModal}
        />

        <CommentPopup
          externalPopupShown={isCommentModalShow}
          externalProductID={null}
          externalProductBrandName={null}
          externalProductName={null}
          setExternalPopupShown={setIsCommentModalShow}
        />

        <Footer />

        <MobileTabBar props={{ highlighted: 'score' }} />
      </main>
    </div>
  );
}
